import { jsx } from "react/jsx-runtime";
import "react";
import { FilterChip } from "../../FilterChip/index.js";
function FilterChipBar({ filterChipData, handleFilterChipClick, selectedFilterChipData, onFilterChipMouseDown }) {
    return /*#__PURE__*/ jsx("div", {
        className: "overflow-x-auto overscroll-x-contain p-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
        children: /*#__PURE__*/ jsx("div", {
            className: "flex w-max gap-1",
            children: filterChipData.map((item)=>/*#__PURE__*/ jsx(FilterChip, {
                    label: item.name,
                    onMouseDown: (e)=>{
                        e.preventDefault();
                        onFilterChipMouseDown?.();
                    },
                    onClick: (e, selected)=>{
                        e?.stopPropagation();
                        e?.preventDefault();
                        handleFilterChipClick(item, selected ?? false);
                    },
                    selected: selectedFilterChipData.has(`${item.filterType}_${item.code}_${item.name}`)
                }, `${item.filterType}_${item.code}_${item.name}`))
        })
    });
}
export default FilterChipBar;
